module.exports = __webpack_public_path__ + "img/product15p.2ab29b8b.png";